<template>
    <header v-show="opacity" ref="container" class="fade-in-header" :style="style">
        <section class="fade-in-header-box">
            <!-- <img class="background" v-if="backgroundImage" :src="backgroundImage" /> -->
            <div v-if="env.isApp" class="gradient_inner_back" @click="handleBackButtonClick">
                <a href="javascript:;">
                    <img src="./images/ic_back.png" alt="返回" />
                </a>
            </div>
            <div v-if="title" class="gradient_title">{{ title }}</div>
            <slot name="title-1"></slot>
            <ul v-if="env.isApp && events && events.length > 0" class="gradient_events">
                <li @click="item.event" v-for="(item, index) in events" :key="index">{{ item.name }}</li>
            </ul>
            <slot v-else name="right"></slot>
        </section>
    </header>
</template>

<script>
import { getNotchHeight } from 'root/common/nativeApi';
import env from 'root/common/util/env.js';

const html = document.documentElement;

export default {
    name: 'FadeInHeader',
    props: {
        // 标题
        title: {
            type: String,
            default: '',
        },
        // 开始渐变的高度
        startOffset: {
            type: Number,
            default: 0,
        },
        // 渐变完成的高度
        endOffset: {
            type: Number,
            default: 0,
        },
        // 自定义返回方法
        onBack: {
            type: Function,
        },
        events: Array,
        backgroundImage: {
            default: '',
            type: String,
        },
        backgroundColor: {
            default: 'rgba(240, 240, 240, 1)',
            type: String,
        },
        zIndex: {
            default: 999,
            type: Number,
        },
        isNeedOpactiy: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            lhHeight: 0, // 高度
            opacity: 0, // 透明度
            env,
        };
    },
    created() {
        if (!this.isNeedOpactiy) {
            this.opacity = 1;
        }
    },
    computed: {
        // 样式
        style() {
            const defaultStyle = {
                zIndex: `${this.zIndex}`,
                opacity: this.opacity,
            };
            const formatStyle = {
                backgroundColor: this.backgroundColor,
            };
            if (this.lhHeight) {
                defaultStyle['padding-top'] = `${this.lhHeight}px`;
            }

            if (this.backgroundImage) {
                formatStyle['background-image'] = `url('${this.backgroundImage}')`;
                formatStyle['background-repeat'] = ' no-repeat';
                formatStyle['background-size'] = 'cover';
                formatStyle['background-position'] = '0 0';
            }

            return { ...defaultStyle, ...formatStyle };
        },
    },
    mounted() {
        this.fixAndroidLH();
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // 获取安卓高度
        fixAndroidLH() {
            if (!env.isAndroid) return;
            const lhHeight = getNotchHeight();

            if (lhHeight) {
                this.lhHeight = lhHeight;
            }
        },
        // 监听滚动回调
        handleScroll() {
            if (!this.isNeedOpactiy) {
                return;
            }
            const $container = this.$refs.container;
            if (!$container) return;
            const windowScrollTop = (window.pageYOffset || html.scrollTop) - (html.clientTop || 0);
            const h = $container.offsetHeight;
            const start = this.startOffset;
            const end = this.endOffset || h;
            this.opacity = Math.max(Math.min(1, (windowScrollTop - start) / end), 0);
        },
        // 监听返回
        handleBackButtonClick() {
            if (this.onBack) {
                this.onBack();
                return;
            }
            if (env.isApp) {
                window.zzc.call('base_backToPreviousPage');
            } else {
                window.history.go(-1);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.fade-in-header {
    z-index: 999;
    position: fixed;
    background: rgba(240, 240, 240, 1);
    top: 0;
    left: 0;
    right: 0;
    padding-top: env(safe-area-inset-top);
    padding-top: constant(safe-area-inset-top);
    opacity: 0;
    height: 0.88rem;
    &-box {
        position: relative;
        height: 0.88rem;
    }
}

.gradient_inner_back {
    position: absolute;
    left: 0;
    top: 0;
    height: 0.88rem;
    width: 1.44rem;
    z-index: 10;
    a {
        position: absolute;
        left: 0.3rem;
        top: 0.2rem;
        width: 0.48rem;
        height: 0.48rem;
        img {
            display: block;
            width: 0.48rem;
            height: 0.48rem;
        }
    }
}

.gradient_title {
    text-align: center;
    font-size: 0.32rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #252220;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 0.88rem;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 0.48rem;
    white-space: nowrap;
    flex: 1;
}
.gradient_events {
    display: flex;
    justify-content: flex-end;
    font-size: 0.28rem;
    color: #333;
    position: absolute;
    right: 0;
    top: 0;
    line-height: 0.52rem;
    li {
        margin-left: 0.2rem;
        height: 0.88rem;
        line-height: 0.88rem;
        position: relative;
        padding-right: 0.32rem;
    }
}
</style>
